import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { VaFormsModule } from '@vendasta/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TagMultiSelectComponent } from './tag-multi-selector.component';
import { TagMultiSelectionStoreService } from './tag-multi-selection.service';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { Observable } from 'rxjs';
import { TagService } from './interface';
import {
  MARKET_ID_TOKEN,
  PARTNER_ID_TOKEN,
  TAG_MULTI_SELECT_CONFIG_TOKEN,
  TAG_SERVICE_TOKEN,
  TagMultiSelectConfig,
} from './tokens';

@NgModule({
  declarations: [TagMultiSelectComponent],
  exports: [TagMultiSelectComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    TranslateModule,
    VaFormsModule,
  ],
  providers: [
    TagMultiSelectionStoreService,
    { provide: PARTNER_ID_TOKEN, deps: [TAG_MULTI_SELECT_CONFIG_TOKEN], useFactory: partnerIdFactory },
    { provide: MARKET_ID_TOKEN, deps: [TAG_MULTI_SELECT_CONFIG_TOKEN], useFactory: marketIdFactory },
    {
      provide: TAG_SERVICE_TOKEN,
      deps: [TAG_MULTI_SELECT_CONFIG_TOKEN],
      useFactory: tagServiceFactory,
    },
  ],
})
export class TagMultiSelectModule {}

function partnerIdFactory(config: TagMultiSelectConfig): Observable<string> {
  return config.partnerId$;
}

function marketIdFactory(config: TagMultiSelectConfig): Observable<string> {
  return config.marketId$;
}

function tagServiceFactory(config: TagMultiSelectConfig): TagService {
  return config.tagService;
}
